import React, {useContext} from 'react';
import {ShowLayoutContext} from "../context/showLayoutContext";
import {ToastContainer} from "react-toastify";
import Header from "../layouts/header";
import Navbar from "../layouts/navbar";
import {Navigate, Route, Routes} from "react-router-dom";
import Home from "../pages/home";
import Index from "../pages/login";
import About from "../pages/about";
import Contact from "../pages/contact";
import AllNotices from "../pages/allNotices";
import Services from "../pages/services";
import ServiceDetails from "../pages/services/details";
import Faq from "../pages/faq";
import ActsRulesOrders from "../pages/actsRulesOrders/index2";
import MediaEvent from "../pages/mediaEvent";
import MediaEventDetails from "../pages/mediaEvent/details";
import Guideline from "../pages/guideline";
import BrandProfile from "../layouts/brandProfile";
import Footer from "../layouts/footer";

const PublicRoutes = () => {
    const [isInLoginPage] = useContext(ShowLayoutContext);
    return (
        <>
            <ToastContainer theme="colored"/>
            {!isInLoginPage && <Header/>}
            {!isInLoginPage && <Navbar/>}
            <Routes>
                <Route path='/' element={<Home/>}/>
                <Route path='/admin/login' element={<Index/>}/>
                <Route path='/about' element={<About/>}/>
                <Route path='/contact' element={<Contact/>}/>
                <Route path='/notices' element={<AllNotices/>}/>
                <Route path='/services' element={<Services/>}/>
                <Route path='/services/:id' element={<ServiceDetails/>}/>
                <Route path='/faq' element={<Faq/>}/>
                <Route path='/acts-rules-orders' element={<ActsRulesOrders/>}/>
                <Route path='/media-events' element={<MediaEvent/>}/>
                <Route path='/media-events/:id' element={<MediaEventDetails/>}/>
                <Route path='/guideline' element={<Guideline/>}/>
                <Route path='*' element={<Navigate to='/'/>}/>
            </Routes>
            {!isInLoginPage && <BrandProfile/>}
            {!isInLoginPage && <Footer/>}
        </>
    );
};

export default PublicRoutes;
